import { useState } from "react";
import { Props_SnippetJobDetailsVideo } from "./JobDetailsVideo.props";

export const convertIframeUrl = (url: string): string => {
  let newUrl = url;

  const youtubeDomains = ["youtube.com", "youtu.be", "m.youtube.com"];

  for (const youtubeDomain of youtubeDomains) {
    if (newUrl.includes(youtubeDomain)) {
      // Handle YouTube Shorts
      if (newUrl.includes("/shorts/")) {
        const videoIdMatch = newUrl.match(/\/shorts\/([a-zA-Z0-9_-]+)/);
        if (videoIdMatch) {
          newUrl = `https://www.youtube-nocookie.com/embed/${videoIdMatch[1]}`;
        }
      }
      // Handle youtu.be short URLs
      else if (newUrl.includes("youtu.be/")) {
        newUrl = newUrl.replace("youtu.be/", "www.youtube-nocookie.com/embed/");
      }
      // Handle watch?v= URLs
      else if (newUrl.includes("watch?v=")) {
        newUrl = newUrl.replace("watch?v=", "embed/");
        newUrl = newUrl.replace(youtubeDomain, "youtube-nocookie.com");
      }
      // Handle other youtube.com URLs (already embedded or direct)
      else {
        newUrl = newUrl.replace(youtubeDomain, "youtube-nocookie.com");
      }

      let separator = newUrl.includes("?") ? "&" : "?";

      if (!newUrl.includes("enablejsapi=")) {
        newUrl = `${newUrl}${separator}enablejsapi=1`;
        separator = "&"; // After first param, always use &
      }

      if (!newUrl.includes("origin=")) {
        newUrl = `${newUrl}${separator}origin=${encodeURIComponent(window.location.origin)}`;
      }

      break;
    }
  }

  // Handle Vimeo URLs
  if (newUrl.includes("vimeo.com")) {
    const match = newUrl.match(/vimeo\.com\/(\d+)/);
    if (match) {
      newUrl = `https://player.vimeo.com/video/${match[1]}`;
    }
  }

  return newUrl;
};

const SnippetJobDetailsVideo = (props: Props_SnippetJobDetailsVideo) => {
  const { video } = props;

  // search for .job-details__video-link .attrax-job-information-widget__dynamic-field-value class and take the value to use as the iframe src

  const iframeSRC = document.querySelector<HTMLElement>(
    ".job-details__video-link .attrax-job-information-widget__dynamic-field-value"
  )?.innerText;

  return iframeSRC ? (
    <section className="snippet-job-details-video">
      <iframe
        className="snippet-job-details-video__video"
        width="560"
        height="315"
        src={convertIframeUrl(iframeSRC ?? "")}
        title="Job Details Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </section>
  ) : null;
};

export default SnippetJobDetailsVideo;
